import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

const header = { Authorization: "Bearer " + sessionStorage.getItem("Token") };

class BCService {
  addBC(bc) {
    return api.post(UtilsUrl.bcURL() + "/addBonCommande", bc);
  }
  getRefBC() {
    return api.get(UtilsUrl.bcURL() + "/getRefBC");
  }

  getBCAndExrats(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getBCEndExtratID/" + idBC);
  }
  validateBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/validateBC/" + idBC);
  }
  deleteBCDraft(idBC) {
    return api.get(UtilsUrl.bcURL() + "/deleteBCDraft/" + idBC);
  }
  getListBCSociete(idUser, idSociete, isSaved, isGenerated, isDeleted) {
    return api.get(
      UtilsUrl.bcURL() +
        "/getListBCSociete/" +
        idUser +
        "/" +
        idSociete +
        "/" +
        isSaved +
        "/" +
        isGenerated +
        "/" +
        isDeleted
    );
  }

  getListBCSocieteFilter(
    idSociete,
    idUser,
    isSaved,
    isGenerated,
    isDeleted,
    month,
    year
  ) {
    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSociete === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSociete);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }
    return api.get(
      UtilsUrl.bcURL() +
        "/getListBCSocieteFilter/" +
        idUser +
        "/" +
        idSupllierForBackend +
        "/" +
        isSaved +
        "/" +
        isGenerated +
        "/" +
        isDeleted +
        "/" +
        monthForBackend +
        "/" +
        yearForBackend
    );
  }
  getBCById(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getBCById/" + idBC);
  }
  getMaxAmountBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getMaxAmountBC/" + idBC);
  }

  payerEspeceAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerEspeceAvanceBC", payement);
  }

  payerVirementAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerVirementAvanceBC", payement);
  }

  payerChequeAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerChequeAvanceBC", payement);
  }
  payerEnLigneAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerEnLigneAvanceBC", payement);
  }
  listAvancePayementBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getAvancesPayementBC/" + idBC);
  }
  // getFacturesByFilterForPayementTask(){

  // }

  getBonDeCommandeByFilterForPayementTask(idUser, idSupplier, month, year) {
    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }

    return api.get(
      UtilsUrl.bcURL() +
        "/getBonDeCommandeByFilterForPayementTask/" +
        idUser +
        "/" +
        idSupllierForBackend +
        "/" +
        monthForBackend +
        "/" +
        yearForBackend
    );

    // return api.get(
    //   `/retail/document/getBonDeCommandeByFilterForPayementTask/${currentUser}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}`
    // );
  }

  retenuSimulator(idUser,percentRetenu,idDocument) {
    return api.get(
      `/retail/payement/retenuSimulator/${idUser}/${percentRetenu}/${idDocument}`
    );
  }
}
export default new BCService();
